/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as PencilIcon } from "../../../resources/images/pencil-line-icon.svg";

/* Styles */
import styles from "./styles";

const AddBookingFieldModal = ({
  showModal,
  setShowModal,
  editItem,
  handleSubmit,
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.addBookingFieldModal}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={<PencilIcon className={classes.iconColor} />}
      modalTitle={
        editItem ? (
          <FormattedMessage id="settings.bookingFields.edit.title" />
        ) : (
          <FormattedMessage id="settings.bookingFields.add.title" />
        )
      }
      modalContent={
        <Content
          setShowModal={setShowModal}
          editItem={editItem}
          handleSubmit={handleSubmit}
        />
      }
      dataTestId="addBookingFieldModal"
    />
  );
};

export default AddBookingFieldModal;
